export default __webpack_public_path__ + "static/media/category.5d68ee48.jpg";